import { ICndn, ISearchCndnReq, ISearchCndnRes } from '@/interfaces/cndn';

import * as baseAdapter from './baseAdapter';

export const searchCndns = async (req: ISearchCndnReq) => {
  const ret = await baseAdapter.post<ISearchCndnRes>(
    '/creditDebitNote/gets',
    req,
  );
  return ret;
};

export const addCndn = async (data: Partial<ICndn>) => {
  const ret = await baseAdapter.post<ICndn>('/creditDebitNote/create', data);
  return ret;
};

export const getCndn = async (id: number) => {
  const ret = await baseAdapter.get<ICndn>('/creditDebitNote/get/' + id);
  return ret?.data;
};

export const deleteCndn = async (id: number) => {
  const ret = await baseAdapter.deleteRequest(`/creditDebitNote/delete/${id}`);
  return ret;
};
